<template>
    <v-dialog :class="$options.name" value="true" persistent max-width="600">
        <v-card>
            <v-card-title :class="`${$options.name}__header`" primary-title class="text-h5 red white--text">
                <v-icon dark> warning </v-icon>
                {{ $t(errorTitle) }}
            </v-card-title>
            <v-card-text class="pa-4">
                {{ errorMessage }}
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <button-app-control :label="$t('Close')" :color="'primary'" text @click="raiseCloseEvent" />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ButtonAppControl } from '../../atoms';

@Component({
    name: 'ErrorDialog',
    components: {
        ButtonAppControl,
    },
})
export default class ErrorDialog extends Vue {
    @Prop({ default: 'System_Error' }) title: string;
    @Prop({ default: '' }) message: string;

    get errorTitle(): string {
        return this.title;
    }
    get errorMessage(): string {
        return this.message;
    }
    raiseCloseEvent(): void {
        this.$emit('clickClose');
    }
}
</script>
